import React from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';
import useAuthorize from '../permissions/hooks/useAuthorize';
import useNotification from '../../libs/notifications/useNotification';
import URLS from './urls';
import { IPrivateRoute } from './types';

const PrivateRoute: React.FC<IPrivateRoute> = ({
  authorizationStrategy,
  requires,
  session,
  features,
  children
}) => {
  const isAuthorized = useAuthorize(requires, authorizationStrategy);
  const notification = useNotification();
  const { t } = useTranslation();

  const redirectToProfile = () => {
    notification('customType', {
      message: t('components.notification.not_authorized.message'),
      type: 'danger',
      icon: 'tim-icons icon-alert-circle-exc',
      autoDismiss: 3,
      place: 'tc'
    });
    return <Navigate to={URLS.USER_PROFILE} />;
  };

  const redirectToLogin = () => {
    return <Navigate to={URLS.SIGNIN} />;
  };

  const isAuthenticate = () => {
    return !!session;
  };

  const hasFeature = () => {
    return (requires && isAuthorized) || !requires;
  };

  const redirectToPage = () => {
    return hasFeature() || features === undefined
      ? children
      : redirectToProfile();
  };

  return isAuthenticate() ? redirectToPage() : redirectToLogin();
};

export default PrivateRoute;
